import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-4 text-foreground-600 text-base">
            关于po18官网app的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <h4 className="font-heading text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}